export const encodeId = (id?: string) =>
    id
        ? encodeURIComponent(id)
              .replace(/%2F/g, '/')
              .replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`)
        : undefined;
